module.exports = __webpack_public_path__ + "media/application/images/svgs/shield-fea663faef2b8134bf2088c442f1939c.svg";